const FrameSizes = [
    64,
    66,
    70,
    72,
    80,
    84,
    88,
    90,
    96,
    98,
    100,
    108,
    110,
    112,
    120,
    126,
    128,
    132,
    140,
    144,
    150,
    154,
    160,
    162,
    168,
    176,
    180,
    192,
    196,
    198,
    200,
    210,
    216,
    220,
    224,
    240,
    242,
    250,
    252,
    256,
    264,
    270,
    280,
    288,
    294,
    300,
    308,
    320,
    324,
    330,
    336,
    350,
    352,
    360,
    378,
    384,
    392,
    396,
    400,
    420,
    432,
    440,
    448,
    450,
    462,
    480,
    484,
    486,
    490,
    500,
    504,
    512,
    528,
    540,
    550,
    560,
    576,
    588,
    594,
    600,
    616,
    630,
    640,
    648,
    660,
    672,
    686,
    700,
    704,
    720,
    726,
    750,
    756,
    768,
    770,
    784,
    792,
    800,
    810,
    840,
    864,
    880,
    882,
    896,
    900,
    924,
    960,
    968,
    972,
    980,
    990,
    1000,
    1008,
    1024,
    1050,
    1056,
    1078,
    1080,
    1100,
    1120,
    1134,
    1152,
    1176,
    1188,
    1200,
    1210,
    1232,
    1250,
    1260,
    1280,
    1296,
    1320,
    1344,
    1350,
    1372,
    1386,
    1400,
    1408,
    1440,
    1452,
    1458,
    1470,
    1500,
    1512,
    1536,
    1540,
    1568,
    1584,
    1600,
    1620,
    1650,
    1680,
    1694,
    1728,
    1750,
    1760,
    1764,
    1782,
    1792,
    1800,
    1848,
    1890,
    1920,
    1936,
    1944,
    1960,
    1980,
    2000,
    2016,
    2048,
    2058,
    2100,
    2112,
    2156,
    2160,
    2178,
    2200,
    2240,
    2250,
    2268,
    2304,
    2310,
    2352,
    2376,
    2400,
    2420,
    2430,
    2450,
    2464,
    2500,
    2520,
    2560,
    2592,
    2640,
    2646,
    2662,
    2688,
    2700,
    2744,
    2750,
    2772,
    2800,
    2816,
    2880,
    2904,
    2916,
    2940,
    2970,
    3000,
    3024,
    3072,
    3080,
    3136,
    3150,
    3168,
    3200,
    3234,
    3240,
    3300,
    3360,
    3388,
    3402,
    3430,
    3456,
    3500,
    3520,
    3528,
    3564,
    3584,
    3600,
    3630,
    3696,
    3750,
    3780,
    3840,
    3850,
    3872,
    3888,
    3920,
    3960,
    4000,
    4032,
    4050,
    4096,
    4116,
    4158,
    4200,
    4224,
    4312,
    4320,
    4356,
    4374,
    4400,
    4410,
    4480,
    4500,
    4536,
    4608,
    4620,
    4704,
    4752,
    4800,
    4802,
    4840,
    4860,
    4900,
    4928,
    4950,
    5000,
    5040,
    5082,
    5120,
    5184,
    5250,
    5280,
    5292,
    5324,
    5346,
    5376,
    5390,
    5400,
    5488,
    5500,
    5544,
    5600,
    5632,
    5670,
    5760,
    5808,
    5832,
    5880,
    5940,
    6000,
    6048,
    6050,
    6144,
    6160,
    6174,
    6250,
    6272,
    6300,
    6336,
    6400,
    6468,
    6480,
    6534,
    6600,
    6720,
    6750,
    6776,
    6804,
    6860,
    6912,
    6930,
    7000,
    7040,
    7056,
    7128,
    7168,
    7200,
    7260,
    7290,
    7350,
    7392,
    7500,
    7546,
    7560,
    7680,
    7700,
    7744,
    7776,
    7840,
    7920,
    7938,
    7986,
    8000,
    8064,
    8100,
    8192,
    8232,
    8250,
    8316,
    8400,
    8448,
    8470,
    8624,
    8640,
    8712,
    8748,
    8750,
    8800,
    8820,
    8910,
    8960,
    9000,
    9072,
    9216,
    9240,
    9408,
    9450,
    9504,
    9600,
    9604,
    9680,
    9702,
    9720,
    9800,
    9856,
    9900,
    10000,
    10080,
    10164,
    10206,
    10240,
    10290,
    10368,
    10500,
    10560,
    10584,
    10648,
    10692,
    10752,
    10780,
    10800,
    10890,
    10976,
    11000,
    11088,
    11200,
    11250,
    11264,
    11340,
    11520,
    11550,
    11616,
    11664,
    11760,
    11858,
    11880,
    12000,
    12096,
    12100,
    12150,
    12250,
    12288,
    12320,
    12348,
    12474,
    12500,
    12544,
    12600,
    12672,
    12800,
    12936,
    12960,
    13068,
    13122,
    13200,
    13230,
    13310,
    13440,
    13500,
    13552,
    13608,
    13720,
    13750,
    13824,
    13860,
    14000,
    14080,
    14112,
    14256,
    14336,
    14400,
    14406,
    14520,
    14580,
    14700,
    14784,
    14850,
    15000,
    15092,
    15120,
    15246,
    15360,
    15400,
    15488,
    15552,
    15680,
    15750,
    15840,
    15876,
    15972,
    16000,
    16038,
    16128,
    16170,
    16200,
    16384,
    16464,
    16500,
    16632,
    16800,
    16896,
    16940,
    17010,
    17150,
    17248,
    17280,
    17424,
    17496,
    17500,
    17600,
    17640,
    17820,
    17920,
    18000,
    18144,
    18150,
    18432,
    18480,
    18522,
    18634,
    18750,
    18816,
    18900,
    19008,
    19200,
    19208,
    19250,
    19360,
    19404,
    19440,
    19600,
    19602,
    19712,
    19800,
    20000,
    20160,
    20250,
    20328,
    20412,
    20480,
    20580,
    20736,
    20790,
    21000,
    21120,
    21168,
    21296,
    21384,
    21504,
    21560,
    21600,
    21780,
    21870,
    21952,
    22000,
    22050,
    22176,
    22400,
    22500,
    22528,
    22638,
    22680,
    23040,
    23100,
    23232,
    23328,
    23520,
    23716,
    23760,
    23814,
    23958,
    24000,
    24010,
    24192,
    24200,
    24300,
    24500,
    24576,
    24640,
    24696,
    24750,
    24948,
    25000,
    25088,
    25200,
    25344,
    25410,
    25600,
    25872,
    25920,
    26136,
    26244,
    26250,
    26400,
    26460,
    26620,
    26730,
    26880,
    26950,
    27000,
    27104,
    27216,
    27440,
    27500,
    27648,
    27720,
    28000,
    28160,
    28224,
    28350,
    28512,
    28672,
    28800,
    28812,
    29040,
    29106,
    29160,
    29282,
    29400,
    29568,
    29700,
    30000,
    30184,
    30240,
    30250,
    30492,
    30618,
    30720,
    30800,
    30870,
    30976,
    31104,
    31250,
    31360,
    31500,
    31680,
    31752,
    31944,
    32000,
    32076,
    32256,
    32340,
    32400,
    32670,
    32768,
    32928,
    33000,
    33264,
    33600,
    33614,
    33750,
    33792,
    33880,
    34020,
    34300,
    34496,
    34560,
    34650,
    34848,
    34992,
    35000,
    35200,
    35280,
    35574,
    35640,
    35840,
    36000,
    36288,
    36300,
    36450,
    36750,
    36864,
    36960,
    37044,
    37268,
    37422,
    37500,
    37632,
    37730,
    37800,
    38016,
    38400,
    38416,
    38500,
    38720,
    38808,
    38880,
    39200,
    39204,
    39366,
    39424,
    39600,
    39690,
    39930,
    40000,
    40320,
    40500,
    40656,
    40824,
    40960,
    41160,
    41250,
    41472,
    41580,
    42000,
    42240,
    42336,
    42350,
    42592,
    42768,
    43008,
    43120,
    43200,
    43218,
    43560,
    43740,
    43750,
    43904,
    44000,
    44100,
    44352,
    44550,
    44800,
    45000,
    45056,
    45276,
    45360,
    45738,
    46080,
    46200,
    46464,
    46656,
    47040,
    47250,
    47432,
    47520,
    47628,
    47916,
    48000,
    48020,
    48114,
    48384,
    48400,
    48510,
    48600,
    49000,
    49152,
    49280,
    49392,
    49500,
    49896,
    50000,
    50176,
    50400,
    50688,
    50820,
    51030,
    51200,
    51450,
    51744,
    51840,
    52272,
    52488,
    52500,
    52800,
    52822,
    52920,
    53240,
    53460,
    53760,
    53900,
    54000,
    54208,
    54432,
    54450,
    54880,
    55000,
    55296,
    55440,
    55566,
    55902,
    56000,
    56250,
    56320,
    56448,
    56700,
    57024,
    57344,
    57600,
    57624,
    57750,
    58080,
    58212,
    58320,
    58564,
    58800,
    58806,
    59136,
    59290,
    59400,
    60000,
    60368,
    60480,
    60500,
    60750,
    60984,
    61236,
    61250,
    61440,
    61600,
    61740,
    61952,
    62208,
    62370,
    62500,
    62720,
    63000,
    63360,
    63504,
    63888,
    64000,
    64152,
    64512,
    64680,
    64800,
    65340,
    65536,
    65610,
    65856,
    66000,
    66150,
    66528,
    66550,
    67200,
    67228,
    67500,
    67584,
    67760,
    67914,
    68040,
    68600,
    68750,
    68992,
    69120,
    69300,
    69696,
    69984,
    70000,
    70400,
    70560,
    71148,
    71280,
    71442,
    71680,
    71874,
    72000,
    72030,
    72576,
    72600,
    72900,
    73500,
    73728,
    73920,
    74088,
    74250,
    74536,
    74844,
    75000,
    75264,
    75460,
    75600,
    76032,
    76230,
    76800,
    76832,
    77000,
    77440,
    77616,
    77760,
    78400,
    78408,
    78732,
    78750,
    78848,
    79200,
    79380,
    79860,
    80000,
    80190,
    80640,
    80850,
    81000,
    81312,
    81648,
    81920,
    82320,
    82500,
    82944,
    83006,
    83160,
    84000,
    84480,
    84672,
    84700,
    85050,
    85184,
    85536,
    85750,
    86016,
    86240,
    86400,
    86436,
    87120,
    87318,
    87480,
    87500,
    87808,
    87846,
    88000,
    88200,
    88704,
    89100,
    89600,
    90000,
    90112,
    90552,
    90720,
    90750,
    91476,
    91854,
    92160,
    92400,
    92610,
    92928,
    93170,
    93312,
    93750,
    94080,
    94500,
    94864,
    95040,
    95256,
    95832,
    96000,
    96040,
    96228,
    96250,
    96768,
    96800,
    97020,
    97200,
    98000,
    98010,
    98304,
    98560,
    98784,
    99000,
    99792,
    100000,
    100352,
    100800,
    100842,
    101250,
    101376,
    101640,
    102060,
    102400,
    102900,
    103488,
    103680,
    103950,
    104544,
    104976,
    105000,
    105600,
    105644,
    105840,
    106480,
    106722,
    106920,
    107520,
    107800,
    108000,
    108416,
    108864,
    108900,
    109350,
    109760,
    110000,
    110250,
    110592,
    110880,
    111132,
    111804,
    112000,
    112266,
    112500,
    112640,
    112896,
    113190,
    113400,
    114048,
    114688,
    115200,
    115248,
    115500,
    116160,
    116424,
    116640,
    117128,
    117600,
    117612,
    118098,
    118272,
    118580,
    118800,
    119070,
    119790,
    120000,
    120050,
    120736,
    120960,
    121000,
    121500,
    121968,
    122472,
    122500,
    122880,
    123200,
    123480,
    123750,
    123904,
    124416,
    124740,
    125000,
    125440,
    126000,
    126720,
    127008,
    127050,
    127776,
    128000,
    128304,
    129024,
    129360,
    129600,
    129654,
    130438,
    130680,
    131072,
    131220,
    131250,
    131712,
    132000,
    132300,
    133056,
    133100,
    133650,
    134400,
    134456,
    134750,
    135000,
    135168,
    135520,
    135828,
    136080,
    137200,
    137214,
    137500,
    137984,
    138240,
    138600,
    139392,
    139968,
    140000,
    140800,
    141120,
    141750,
    142296,
    142560,
    142884,
    143360,
    143748,
    144000,
    144060,
    144342,
    145152,
    145200,
    145530,
    145800,
    146410,
    147000,
    147456,
    147840,
    148176,
    148500,
    149072,
    149688,
    150000,
    150528,
    150920,
    151200,
    151250,
    152064,
    152460,
    153090,
    153600,
    153664,
    154000,
    154350,
    154880,
    155232,
    155520,
    156250,
    156800,
    156816,
    157464,
    157500,
    157696,
    158400,
    158466,
    158760,
    159720,
    160000,
    160380,
    161280,
    161700,
    162000,
    162624,
    163296,
    163350,
    163840,
    164640,
    165000,
    165888,
    166012,
    166320,
    166698,
    167706,
    168000,
    168070,
    168750,
    168960,
    169344,
    169400,
    170100,
    170368,
    171072,
    171500,
    172032,
    172480,
    172800,
    172872,
    173250,
    174240,
    174636,
    174960,
    175000,
    175616,
    175692,
    176000,
    176400,
    176418,
    177408,
    177870,
    178200,
    179200,
    180000,
    180224,
    181104,
    181440,
    181500,
    182250,
    182952,
    183708,
    183750,
    184320,
    184800,
    185220,
    185856,
    186340,
    186624,
    187110,
    187500,
    188160,
    188650,
    189000,
    189728,
    190080,
    190512,
    191664,
    192000,
    192080,
    192456,
    192500,
    193536,
    193600,
    194040,
    194400,
    196000,
    196020,
    196608,
    196830,
    197120,
    197568,
    198000,
    198450,
    199584,
    199650,
    200000,
    200704,
    201600,
    201684,
    202500,
    202752,
    203280,
    203742,
    204120,
    204800,
    204974,
    205800,
    206250,
    206976,
    207360,
    207900,
    209088,
    209952,
    210000,
    211200,
    211288,
    211680,
    211750,
    212960,
    213444,
    213840,
    214326,
    215040,
    215600,
    215622,
    216000,
    216090,
    216832,
    217728,
    217800,
    218700,
    218750,
    219520,
    220000,
    220500,
    221184,
    221760,
    222264,
    222750,
    223608,
    224000,
    224532,
    225000,
    225280,
    225792,
    226380,
    226800,
    228096,
    228690,
    229376,
    230400,
    230496,
    231000,
    232320,
    232848,
    233280,
    234256,
    235200,
    235224,
    235298,
    236196,
    236250,
    236544,
    237160,
    237600,
    238140,
    239580,
    240000,
    240100,
    240570,
    241472,
    241920,
    242000,
    242550,
    243000,
    243936,
    244944,
    245000,
    245760,
    246400,
    246960,
    247500,
    247808,
    248832,
    249018,
    249480,
    250000,
    250880,
    252000,
    253440,
    254016,
    254100,
    255150,
    255552,
    256000,
    256608,
    257250,
    258048,
    258720,
    259200,
    259308,
    260876,
    261360,
    261954,
    262144
];

export default FrameSizes;
